import React from 'react';
import {func} from 'prop-types';
import {useTranslation} from 'react-i18next';

import ZoomToButton from '@components/common/ZoomToButton';

const ZoomToFeatureButton = ({onClick}) => {
  const {t} = useTranslation();

  return (
    <ZoomToButton tooltipText={t('feature.zoomTooltip')} onClick={onClick} />
  );
};

ZoomToFeatureButton.propTypes = {
  onClick: func,
};

export default ZoomToFeatureButton;
